import React, { createContext, useContext, useEffect, useReducer } from "react";
import apiCall from "../components/Api/api";
import { metaReducer } from "../reducers/metaReducer";

//Create context
export const MetaContext = createContext();

//Initial state
const initialState = {
  accommodation: [],
  safariSession: [],
  metaLoading: true

};

//Provider
const MetaProvider = ({ children }) => {
  const [metaState, metaDispatch] = useReducer(metaReducer, initialState);

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        metaDispatch({ type: "SET_META_LOADING", payload: true });
        // Or example of parallel requests using Promise.all
        const [
          accommoRes,
          safariSessRes
        ] = await Promise.allSettled([
          apiCall({ url: `meta/accommodation`, method: "GET" }),
          apiCall({ url: `meta/safari-session`, method: "GET" }),

        ]);

        if (accommoRes.status === "fulfilled" && accommoRes.value.status === 200) {
          const data = accommoRes.value.data?.MetaAccommodation?.data;
          const options = data.map((park) => ({
            label: park.title,
            value: park.id,
          }));
    
          metaDispatch({ type: "SET_META_ACCOMMODATION", payload: options });
        } else {
          console.error("Accommodation API failed:", accommoRes.reason);
        }
        if (safariSessRes.status === "fulfilled" && safariSessRes.value.status === 200) {
          const data = safariSessRes.value.data?.MetaSafariSession?.data;
          const options = data.map((park) => ({
            label: park.title,
            value: park.id,
          }));
    
          metaDispatch({ type: "SET_META_SAFARI_SESSION", payload: options });
        } else {
          console.error("Safari Session API failed:", safariSessRes.reason);
        }


      } catch (error) {

        console.error(error)
        metaDispatch({ type: "SET_META_LOADING", payload: false });
      }finally{
        metaDispatch({ type: "SET_META_LOADING", payload: false });
      }
    };

    // fetch all meta
    fetchMeta();
  }, []);
  return (
    <MetaContext.Provider
      value={{
        ...metaState,
        metaDispatch,
      }}
    >
      {children}
    </MetaContext.Provider>
  );
};

//hook
export const useMetaContext = () => useContext(MetaContext);

export default MetaProvider;
